export enum HrisProvider {
  BambooHr = 'bamboo_hr',
  FactorialHr = 'factorial_hr',
  HiBob = 'hi_bob',
  Personio = 'personio',
  Zelt = 'zelt',
}
